import React from "react";
import "./ComponentCreate.scss";

const ComponentCreate = () => {
  return (
    <div className="main-right-side-section">
      <div className="component-main-section pt-20 pb-8">
        <section>
          <div className="component-section-1">
            <div className="component-section-1-inner">
              <h4 className="font-Manrope text-2xl font-bold text-homeblack">How to Create a Component in React js ?</h4>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};


// import React, { useState } from 'react';
// import { ReactLinkPreview } from 'react-link-preview';

// const LinkPreviewComponent = () => {
//   const [url, setUrl] = useState('');

//   const handleInputChange = (event) => {
//     setUrl(event.target.value);
//   };

//   return (
//     <div>
//       <input
//         type="text"
//         value={url}
//         onChange={handleInputChange}
//         placeholder="Enter URL"
//       />
//       {url && <ReactLinkPreview url={url} />}
//     </div>
//   );
// };



ComponentCreate.propTypes = {};

ComponentCreate.defaultProps = {};

export default ComponentCreate;
// export default LinkPreviewComponent;
